import React from 'react';
import { Spinner } from 'react-bootstrap';
import DataTable from '../../DataTable/datatable.component';
import { Nav } from 'react-bootstrap';
import CommonConfigPage from './CommonConfigPage';
import { useGetSites } from '../../../hooks/useSites';
import SiteEditDialog from './Dialogs/SiteEditDialog';

function SitesTable({ onRowClick, refresh }) {

    const { sites, loading } = useGetSites(refresh);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'fuzzyText',
            Cell: (props) => {
                return <Nav><Nav.Link onClick={() => { onRowClick(props.row.original); }}>{props.value}</Nav.Link></Nav>
            }
        },
        {
            Header: 'Site Code',
            accessor: 'siteCode',
            filter: 'fuzzyText'
        }
    ];

    if (loading) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    return <DataTable id="Sites" tableColumns={tableColumns} tableData={sites} />
}

function SiteConfiguration() {
    const getNewSite = () => {
        return { id: null, siteCode: "", name: "" }
    };

    return (
        <CommonConfigPage
            title="Sites"
            table={(showEditDialog, refreshList) => <SitesTable onRowClick={showEditDialog} refresh={refreshList} />}
            dialog={(dialogData, setDialogData, showDialog, closeDialog) => <SiteEditDialog dialogData={dialogData} setDialogData={setDialogData} showDialog={showDialog} closeDialog={closeDialog} />}
            getNewConfigObject={getNewSite}
        />
    );
}

export default SiteConfiguration;